import { ListItemSchema } from 'cms/schemaTypes/staticPages/objects/listItem'
import { PortableTextBlock } from 'next-sanity'

import CustomPortableText from 'lib/sanity/richText/CustomPortableText'
import FormattedText from 'shared/ui/FormattedText'

import OrderSteps from '../landings/Steps'
import {
  SectionContainer,
  SectionContent,
  SectionTitle
} from '../landings/styles'

import styles from './HowToReturnSection.module.scss'

interface HowToReturnSectionProps {
  header: string
  description?: PortableTextBlock
  sectionList: ListItemSchema[]
}

const HowToReturnSection = ({
  header,
  description,
  sectionList
}: HowToReturnSectionProps) => {
  const list = sectionList.map(({ content }) => content || [])

  return (
    <SectionContainer>
      <SectionContent
        $top={16}
        $bottom={16}
        $bottomMobile={16}
        $topMobile={16}
        className={styles.sectionContent}
      >
        <SectionTitle
          $size='3xl'
          $lineHeight={1.5}
          $center
          className={styles.sectionTitle}
        >
          <FormattedText text={header} />
        </SectionTitle>

        <div className={styles.descriptionContainer}>
          <CustomPortableText value={description || []} />
        </div>
        <OrderSteps
          steps={list.map((content, index) => (
            <CustomPortableText
              value={content}
              preventWidow={false}
              key={index}
            />
          ))}
        />
      </SectionContent>
    </SectionContainer>
  )
}

export default HowToReturnSection
